module.exports = __webpack_public_path__ + "static/hr_capabilities_7-119f9aec28a3bb01c1aa19f788c51482.png";